import { Directive, HostListener, ElementRef } from '@angular/core';
import { DEFAULT_NO_OPTION_IMAGE } from "../constants";

@Directive({
  selector: 'img[ddAppImageError]'
})
export class ImageErrorDirective {
  constructor(private el: ElementRef) {}

  @HostListener('error')
  onError() {
    const imgElement = this.el.nativeElement as HTMLImageElement;
    imgElement.src = DEFAULT_NO_OPTION_IMAGE;
  }
}
